import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import { Link } from "react-router-dom"
import ReactApexChart from "react-apexcharts"

//actions
import { getCampusVirtualIngresosEgresos } from "../../store/actions"

//selectors
import {
  useCampusVirtualIngresosEgresos,
  useCampusVirtualIdCampus,
} from "store/selectors"

//redux
import { useDispatch } from "react-redux"

import getChartColorsArray from "../../components/Common/ChartsDynamicColor"

const primerDiaMes = new Date(
  new Date().getFullYear(),
  new Date().getMonth(),
  1
)

const IngresosEgresosComponent = ({ dataColors }) => {
  const appearingChartColors = getChartColorsArray(dataColors)
  const dispatch = useDispatch()

  const [selectedPrimerDiaMes, setPrimerDiaMes] = useState(primerDiaMes)
  const [selectedReferenceDate, setSelectedReferenceDate] = useState(new Date())
  const [series, setSeries] = useState([])
  const [ingresosTotales, setIngresosTotales] = useState(0)
  const [egresosTotales, setEgresosTotales] = useState(0)

  const ingresosEgresos = useCampusVirtualIngresosEgresos()
  const idCampus = useCampusVirtualIdCampus()

  const options = {
    chart: {
      toolbar: "false",
      dropShadow: {
        enabled: !0,
        color: "#000",
        top: 18,
        left: 7,
        blur: 8,
        opacity: 0.2,
      },
    },
    dataLabels: {
      enabled: !1,
    },
    colors: appearingChartColors,
    stroke: {
      curve: "smooth",
      width: 3,
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          if (value >= 1000000) {
            return parseInt(value / 1000000) + "M" // Millones
          } else if (value >= 1000) {
            return parseInt(value / 1000) + "K" // Miles
          }
          return parseInt(value) // Menos de 1000, se muestra normal
        },
        style: {
          fontWeight: "bold", // Hace que el texto sea en negritas
          fontSize: "14px", // Ajusta el tamaño si lo necesitas
          colors: "#333", // Color del texto (puedes cambiarlo)
        },
      },
    },
  }

  /*
  call api action to receive data
  */
  useEffect(() => {
    dispatch(
      getCampusVirtualIngresosEgresos({
        nombreSolicitud: "getdingresosegresosxmes",
        idCampus: idCampus,
        mes: primerDiaMes.getMonth() + 1,
        ano: primerDiaMes.getFullYear(),
      })
    )
  }, [dispatch])

  useEffect(() => {
    if (ingresosEgresos) {
      //
      if (!Array.isArray(ingresosEgresos)) {
        console.error("Error: La variable 'ingresosEgresos' no es un array.")
        return []
      }
      // Obtener el número de días del mes dado
      const fechaReferencia = selectedReferenceDate
      //
      const mes = fechaReferencia.getUTCMonth() + 1 // getUTCMonth() para evitar problemas de zona horaria
      //console.log("mes", mes)

      const anio = fechaReferencia.getUTCFullYear() // getUTCFullYear() para evitar problemas de zona horaria
      //console.log("anio", anio)

      const diasEnMes = new Date(anio, mes, 0).getDate()

      // Inicializar un arreglo con ceros para cada día del mes
      let ingresosPorDia = new Array(diasEnMes).fill(0)
      let egresosPorDia = new Array(diasEnMes).fill(0)
      let ingresosTotales = 0
      let egresosTotales = 0

      // Recorrer los datos y sumar ingresos por día
      ingresosEgresos.forEach(item => {
        let fecha = new Date(item.Fecha)
        let dia = fecha.getDate() // Obtener el día del mes
        ingresosPorDia[dia - 1] += item.Total_Ingresos // Acumular ingresos en la posición correspondiente
        egresosPorDia[dia - 1] += item.Total_Gastos // Acumular ingresos en la posición correspondiente
        ingresosTotales = ingresosTotales + item.Total_Ingresos
        egresosTotales = egresosTotales + item.Total_Gastos
      })

      const series = [
        {
          name: "Ingreso",
          data: [...ingresosPorDia],
        },
        {
          name: "Egreso",
          data: [...egresosPorDia],
        },
      ]

      setIngresosTotales(ingresosTotales)
      setEgresosTotales(egresosTotales)
      setSeries(series)
    }
  }, [ingresosEgresos])

  // Ejecutar solo cuando idCampus cambie
  useEffect(() => {
    if (idCampus > 0) {
      const date = selectedReferenceDate

      const mes = date.getUTCMonth() + 1 // getUTCMonth() para evitar problemas de zona horaria
      //console.log("mes", mes)

      const anio = date.getUTCFullYear() // getUTCFullYear() para evitar problemas de zona horaria
      //console.log("anio", anio)

      dispatch(
        getCampusVirtualIngresosEgresos({
          nombreSolicitud: "getdingresosegresosxmes",
          idCampus: idCampus,
          mes: mes,
          ano: anio,
        })
      )
    }
  }, [dispatch, idCampus])

  const onChangeMonth = value => {
    //console.log(value) // 2025-01-01

    // Asegurar que la fecha se interprete correctamente en UTC
    const date = new Date(`${value}T00:00:00Z`)
    setSelectedReferenceDate(date)

    const mes = date.getUTCMonth() + 1 // getUTCMonth() para evitar problemas de zona horaria
    //console.log("mes", mes)

    const anio = date.getUTCFullYear() // getUTCFullYear() para evitar problemas de zona horaria
    //console.log("anio", anio)

    setPrimerDiaMes(value)

    dispatch(
      getCampusVirtualIngresosEgresos({
        nombreSolicitud: "getdingresosegresosxmes",
        idCampus: idCampus,
        mes: mes,
        ano: anio,
      })
    )
  }

  const generateMonthOptions = () => {
    const months = [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ]
    const currentDate = new Date()

    return Array.from({ length: 12 }, (_, i) => {
      const newDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - i,
        1
      )
      const year = newDate.getFullYear()
      const month = newDate.getMonth() // 0-based index

      return {
        value: `${year}-${String(month + 1).padStart(2, "0")}-01`, // Formato YYYY-MM-01
        label: `${months[month]} ${year.toString().slice(-2)}`, // Ejemplo: "Feb 25"
      }
    })
  }

  return (
    <React.Fragment>
      <Col xl="12">
        <Card>
          <CardBody>
            <div className="clearfix">
              <div className="float-end">
                <div className="input-group input-group-sm">
                  <select
                    className="form-select form-select-sm"
                    value={selectedPrimerDiaMes}
                    onChange={e => {
                      onChangeMonth(e.target.value)
                    }}
                  >
                    {" "}
                    {generateMonthOptions().map(({ value, label }) => (
                      <option key={value} value={value}>
                        {label}
                      </option>
                    ))}
                  </select>
                  <label className="input-group-text">Fecha</label>
                </div>
              </div>
              <h4 className="card-title mb-4">Ingresos vs Egresos</h4>
            </div>

            <Row>
              <Col lg="4">
                <div className="text-muted">
                  <div className="mb-4">
                    <p>Ingresos este mes</p>
                    <h4>{`$${ingresosTotales.toLocaleString()}`}</h4>
                    <div>
                      <span className="badge badge-soft-success font-size-12 me-1">
                        {" "}
                        + 0.2%{" "}
                      </span>{" "}
                      con respecto al período anterior.
                    </div>
                  </div>

                  <div>
                    <Link to="#" className="btn btn-primary  btn-sm">
                      View Details{" "}
                      <i className="mdi mdi-chevron-right ms-1"></i>
                    </Link>
                  </div>

                  <div className="mt-4">
                    <p className="mb-2">Egresos</p>
                    <h5>{`$${egresosTotales.toLocaleString()}`}</h5>
                  </div>
                </div>
              </Col>

              <Col lg="8">
                <div id="line-chart" dir="ltr">
                  <ReactApexChart
                    series={series}
                    options={options}
                    type="line"
                    height={320}
                    className="apex-charts"
                  />
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  )
}

export default IngresosEgresosComponent
